import { render, staticRenderFns } from "./SmsGroup.vue?vue&type=template&id=5ab8e8b9&"
import script from "./SmsGroup.vue?vue&type=script&lang=ts&"
export * from "./SmsGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports